// Shared helpers for applying and removing icon hover styles on BPMN .djs-visual elements.
// Used by the highlight layer in layer.ts to sync icon colors with the [data-hover] state.

const MAIN_SHAPE_SELECTOR = ":scope > rect, :scope > circle, :scope > polygon";
const ICON_SELECTOR = "path, circle, polygon, rect, polyline, ellipse";

/**
 * Apply hover styles to icon elements within a .djs-visual group.
 * Reads the data-stekz-fill / data-stekz-stroke markers set by StekzRenderer
 * so classification is reliable regardless of whether bpmn-js used SVG
 * presentation attributes or inline styles for the original colors.
 * Skips elements without a main bounding shape (connections, labels).
 */
export function applyIconHoverStyles(visuals: SVGElement): void {
    const mainShape = visuals.querySelector<SVGElement>(MAIN_SHAPE_SELECTOR);
    if (!mainShape) return;

    visuals.querySelectorAll<SVGElement>(ICON_SELECTOR).forEach((el) => {
        if (el === mainShape) return;
        const fillType = el.getAttribute("data-stekz-fill");
        if (fillType === "background") {
            el.style.fill = "var(--stekz-primary-color)";
        } else if (fillType === "icon") {
            el.style.fill = "white";
        }
        if (el.hasAttribute("data-stekz-stroke")) {
            el.style.stroke = "white";
        }
    });
}

/**
 * Remove hover styles from icon elements by restoring the renderer's base values.
 * Uses the same data-stekz-fill / data-stekz-stroke markers to restore to
 * the exact CSS variables the renderer applied, so no removeProperty is needed.
 * Skips elements without a main bounding shape.
 */
export function removeIconHoverStyles(visuals: SVGElement): void {
    const mainShape = visuals.querySelector<SVGElement>(MAIN_SHAPE_SELECTOR);
    if (!mainShape) return;

    visuals.querySelectorAll<SVGElement>(ICON_SELECTOR).forEach((el) => {
        if (el === mainShape) return;
        const fillType = el.getAttribute("data-stekz-fill");
        if (fillType === "background") {
            el.style.fill = "var(--p-content-background)";
        } else if (fillType === "icon") {
            el.style.fill = "var(--text-color)";
        }
        if (el.hasAttribute("data-stekz-stroke")) {
            el.style.stroke = "var(--text-color)";
        }
    });
}
